<template>
    <Modal
      :show.sync="isOpen"
      :on-close="onCloseModal"
    >
    <div v-if="!isLoading" :key="componentRerenderKey">
        <div class="mb_24">
            <h2 class="font_regular font_600 text_20">{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.FORM_TITLE')}}</h2>
        </div>

        <div class="main_modal_container">
      <!-- <label v-if="!initialHookType" class="input_label mb_4" for="">
        Tool type
        <div class="tool_types mt_8">
            <button :class="{ active_btn: toolType === 'webhook' }" @click="toolType = 'webhook'">{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.TYPE.WEB')}}</button>
            <button :class="{ active_btn: toolType === 'client' }" @click="toolType = 'client'">{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.TYPE.CLIENT')}}</button>
        </div>
      </label> -->

        <!-- config  -->
        <InputCard
            :label="'Configuration'"
            class="llm_tool_input_field mt_20"
        >
            <div class="field_wrapper px_10 py_14 my_4">
                <InputField
                v-model="config.name"
                :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.NAME.LABEL')"
                type="text"
                :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.NAME.PLACEHOLDER')"
                :disabled="tool && tool.id && !isDuplicateCreate ? true:false"
                :error="$v.config.name.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.NAME.ERROR'): ''"
                />
                <InputField
                    v-model="config.description"
                    :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.DESCRIPTION.LABEL')"
                    type="textarea"
                    :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.DESCRIPTION.PLACEHOLDER')"
                    class="msg_textarea"
                    :error="$v.config.description.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.DESCRIPTION.ERROR'): ''"
                />
                <div v-if="isHook" class="dropdown_input_group">
                    <MultiselectDropdown
                        :label="'Method'"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="config.method"
                            :options="methods"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>
                    <InputField
                    v-model="config.url"
                    :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.URL.LABEL')"
                    :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.URL.PLACEHOLDER')"
                    type="text"
                    :error="$v.config.url.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.URL.ERROR'): ''"
                    @blur="onBlurUrl"
                    />
                </div>
                <!-- waite for response checkbox -->
                <CheckboxInput
                    v-if="isClient"
                    v-model="config.isWaitForRes"
                    :classNameWrapper="'param_check_label'"
                    :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.WAITING.LABEL')"
                    @onToggle="onToggleWaitForResponse"
                />
                <InputSlot
                    v-if="isHook || (isClient && config.isWaitForRes)"
                    :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.CONFIG.RES_TIME.LABEL')"

                    classNameLabel="llm_dropdown"
                >
                    <SliderRangeInput v-model="config.timeout" :min="0" :max="120" :step="1" />
                </InputSlot>
            </div>
        </InputCard>

        <!-- header config  -->
        <InputCard
            v-if="isHook"
            :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.SECTION_LABEL')"
            class="llm_tool_input_field tool_section mt_40"
        >
            <div v-for="(header,index) in headers" class="field_wrapper px_10 py_14 my_4 mt_22" :key="index">
                <div class="dropdown_input_group">
                    <MultiselectDropdown
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.TYPE.LABEL')"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="header.headerType"
                            :options="headerTypes"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.TYPE.PLACEHOLDER')"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                            @select="header.headerValue = null"
                        />
                    </MultiselectDropdown>
                    <InputField
                        v-model="header.name"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.NAME.LABEL')"
                        type="text"
                        :error="$v.headers.$each[index].name.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.NAME.ERROR') : ''"
                    />
                </div>
                <div>
                    <InputField
                        v-if="header.headerType.value === 'value'"
                        v-model="header.headerValue"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.VALUE.LABEL')"
                        type="text"
                        class="msg_textarea"
                        :error="$v.headers.$each[index].headerValue.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.VALUE.ERROR') : ''"
                    />
                    <MultiselectDropdown
                        v-if="header.headerType.value === 'secret'"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.SECRET.LABEL')"
                        classNameLabel="llm_dropdown"
                        :error="$v.headers.$each[index].headerValue.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.SECRET.ERROR') : ''"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="header.headerValue"
                            :options="secretList"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>
                    <!-- <MultiselectDropdown
                        v-if="header.headerType.value === 'dynamicVariable'"
                        :label="'Variable Name'"
                        classNameLabel="llm_dropdown"
                        :error="$v.headers.$each[index].headerValue.$error ? 'Required' : ''"
                    >
                        <multiselect
                            v-model="header.headerValue"
                            class="column small-12"
                            :options="variableList"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                        />
                    </MultiselectDropdown> -->
                </div>
                <div>
                    <woot-button
                        style="margin-left:auto; display:block;"
                        variant="smooth"
                        color-scheme="primary"
                        size="small"
                        @click="deleteAHeader(index)"
                    >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BTNS.DELETE')}}</woot-button>
                </div>
            </div>
            <div class="add_btn_center py_14">
                <woot-button
                    variant="smooth"
                    color-scheme="primary"
                    size="small"
                    @click="addNewHeader"
                >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.HEADER.ADD_BUTTON')}}</woot-button>
            </div>
        </InputCard>

        <!-- path params  -->
        <InputCard
            v-if="isHook"
            :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.SECTION_LABEL')"
            class="llm_tool_input_field tool_section mt_40"
        >
            <div v-for="(item,index) in pathParams" class="field_wrapper px_10 py_14 my_4 mt_22" :key="index">
                <div class="dropdown_input_group">
                    <MultiselectDropdown
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.DATA_TYPE.LABEL')"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="item.type"
                            :options="paramDataTypes"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>
                    <InputField
                        v-model="item.id"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.IDENTIFIER.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.IDENTIFIER.PLACEHOLDER')"
                        type="text"
                        :disabled="true"
                        :error="$v.pathParams.$each[index].id.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.IDENTIFIER.ERROR') : ''"
                    />
                </div>
                <MultiselectDropdown
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.VALUE_TYPE.LABEL')"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="item.value_type"
                            :options="paramValueTypes"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                            @select="function(selectedItem){onSelectValueTypeOnPathParam(selectedItem,index)}"
                        />
                        <!-- onSelectValueTypeOnPathParam -->
                            <!-- @select="item.pathValue = null" -->
                    </MultiselectDropdown>
                <div>
                    <InputField
                        v-if="item.value_type.value === 'llmPrompt'"
                        v-model="item.description"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.DESCRIPTION.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.DESCRIPTION.PLACEHOLDER')"
                        type="textarea"
                        class="msg_textarea"
                        :error="$v.pathParams.$each[index].description.$error ?  $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.DESCRIPTION.ERROR') : ''"
                    />
                    <!-- <DynamicVariablePiker
                        v-if="item.value_type.value === 'dynamicVariable'"
                        :item="item"
                        :options="agentVariables"
                        :error="$v.pathParams.$each[index].dynamic_variable.$error ? 'Required' : ''"
                    /> -->
                    <MultiselectDropdown
                        v-if="item.value_type.value === 'dynamicVariable'"
                        :label="'Variable Name'"
                        classNameLabel="llm_dropdown"
                        :error="$v.pathParams.$each[index].dynamic_variable.$error ? 'Required' : ''"
                    >
                        <multiselect
                            v-model="item.dynamic_variable"
                            class="column small-12"
                            :options="agentVariables"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="name"
                            label="name"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>

                    <InputField
                        v-if="item.value_type.value === 'constantVariable'"
                        v-model="item.constant_value"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.CONSTANT_VALUE.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.CONSTANT_VALUE.PLACEHOLDER')"
                        type="textarea"
                        class="msg_textarea"
                        :error="$v.pathParams.$each[index].constant_value.$error ?  $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.PATH_PARAMS.CONSTANT_VALUE.ERROR') : ''"
                    />
                </div>
            </div>
        </InputCard>


        <!-- Query params  -->
        <InputCard
            :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.SECTION_LABEL')"
            class="llm_tool_input_field tool_section mt_40"
        >

            <div v-for="(item,index) in queryParams" class="field_wrapper px_10 py_14 my_4 mt_22" :key="index">
                <div class="dropdown_input_group">
                    <MultiselectDropdown
                         :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.TYPE.LABEL')"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="item.type"
                            :options="paramDataTypes"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>
                    <InputField
                        v-model="item.id"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.IDENTIFIER.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.IDENTIFIER.PLACEHOLDER')"
                        type="text"
                        :error="$v.queryParams.$each[index].id.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.IDENTIFIER.ERROR') : ''"
                    />
                </div>
                <CheckboxInput
                    v-model="item.required"
                    :classNameWrapper="'param_check_label'"
                    :label="'Required'"
                    @onToggle="onToggleQueryParamRequired(index)"
                />
                <MultiselectDropdown
                        :label="'Value Type'"
                        classNameLabel="llm_dropdown"
                    >
                        <multiselect
                            class="column small-12"
                            v-model="item.value_type"
                            :options="paramValueTypes"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="value"
                            label="label"
                            :selectLabel="''"
                            @select="function(selectedItem){onSelectValueTypeOnQueryParam(selectedItem,index)}"
                        />
                            <!-- @select="item.queryValue = null" -->
                    </MultiselectDropdown>
                <div>
                    <InputField
                        v-if="item.value_type.value === 'llmPrompt'"
                        v-model="item.description"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.DESCRIPTION.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.DESCRIPTION.PLACEHOLDER')"
                        type="textarea"
                        class="msg_textarea"
                        :error="$v.queryParams.$each[index].description.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.DESCRIPTION.ERROR') : ''"
                    />
                    <!-- <DynamicVariablePiker
                        v-if="item.value_type.value === 'dynamicVariable'"
                        :item="item"
                        :options="agentVariables"
                        :error="$v.queryParams.$each[index].dynamic_variable.$error ? 'Required' : ''"
                    /> -->
                    <MultiselectDropdown
                        v-if="item.value_type.value === 'dynamicVariable'"
                        :label="'Variable Name'"
                        classNameLabel="llm_dropdown"
                        :error="$v.queryParams.$each[index].dynamic_variable.$error ? 'Required' : ''"
                    >
                        <multiselect
                            v-model="item.dynamic_variable"
                            class="column small-12"
                            :options="agentVariables"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            track-by="name"
                            label="name"
                            :selectLabel="''"
                        />
                    </MultiselectDropdown>
                    <InputField
                        v-if="item.value_type.value === 'constantVariable'"
                        v-model="item.constant_value"
                        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.CONSTANT_VALUE.LABEL')"
                        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.CONSTANT_VALUE.PLACEHOLDER')"
                        type="textarea"
                        class="msg_textarea"
                        :error="$v.queryParams.$each[index].constant_value.$error ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.CONSTANT_VALUE.ERROR') : ''"
                    />
                </div>
                <div>
                    <woot-button
                        style="margin-left:auto; display:block;"
                        variant="smooth"
                        color-scheme="primary"
                        size="small"
                        @click="deleteQueryParam(index)"
                    >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BTNS.DELETE')}}</woot-button>
                </div>
            </div>
            <div class="add_btn_center py_14">
                <woot-button
                    variant="smooth"
                    color-scheme="primary"
                    size="small"
                    @click="addNewQueryParams"
                >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.QUERY_PARAMS.ADD_BUTTON')}}</woot-button>
            </div>
        </InputCard>

        <!-- body params  -->
        <InputCard
            v-if="isHook"
            :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.SECTION_LABEL')"
            class="llm_tool_input_field tool_section mt_40"
        >
            <div class="add_btn">
                <woot-button
                    variant="smooth"
                    color-scheme="primary"
                    size="small"
                    @click="enableBodyParams"
                >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.ENABLE_BUTTON')}}</woot-button>
            </div>
            <section v-if="body.enabled" class="field_wrapper px_10 py_14 my_4 mt_30">
                <InputField
                    v-model="body.description"
                    :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.LABEL')"
                    :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.PLACEHOLDER')"
                    type="textarea"
                    class="msg_textarea"
                    :error="bodyErr && bodyErr.description && bodyErr.description._errors ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.ERROR') : ''"
                />

                <!-- new body logic -->
                <div class="bg-light px_12 py_12" style="border-radius:8px;">
                    <label>
                        {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.LABEL')}}
                    </label>

                    <BodyNestedProprty
                        v-for="(property,index) in body.properties"
                        :property="property"
                        :bodyDataTypes="bodyDataTypes"
                        :propertyValueTypes="paramValueTypes"
                        :variableList="variableList"
                        :key="index"
                        :index="index"
                        :propertyList="body.properties"
                        :agentVariables="agentVariables"
                        :error="(bodyErr.properties && bodyErr.properties[index]) || {}"
                    />
                        <!-- :error="$v.body.$each[index].id.$error ? 'Required' : ''" -->
                        <!-- @deletePropertyByIdx="deletePropertyByIdx" -->

                    <div class="add_body_property_btn py_20">
                        <woot-button
                            variant="smooth"
                            color-scheme="primary"
                            size="small"
                            @click="addBodyProperty"
                        >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.ADD_BUTTON')}}</woot-button>
                    </div>
                </div>

            </section>

        </InputCard>

         <!-- Dynamic Variables  -->
        <!-- <InputCard
            :label="'Dynamic variables'"
            class="llm_tool_input_field tool_section mt_40"
        >
            <div class="add_btn">
                <woot-button
                    variant="smooth"
                    color-scheme="primary"
                    size="small"
                    @click="addNewVariable"
                >Add Variable</woot-button>
            </div>
            <div class="field_wrapper px_10 py_14 my_4 mt_22">
                <div v-for="(item,index) in variableList" class="variable_input_group" :key="index">
                    <InputField
                        v-model="item.label"
                        :label="''"
                        type="text"
                        class="msg_textarea"
                        :placeholder="'Variable name'"
                    />
                    <InputField
                        v-model="item.value"
                        :label="''"
                        type="text"
                        class="msg_textarea"
                        :placeholder="'Variable value'"
                    />
                    <div>
                        <woot-button
                            variant="smooth"
                            size="small"
                            color-scheme="secondary"
                            icon="delete"
                            class-names="grey-btn btn-width-auto mt_12 ml_5"
                            @click.stop="deleteVariable(index)"
                        >
                        </woot-button>
                    </div>
                </div>
            </div>
        </InputCard> -->


        <div class="my_40">
            <woot-button
                color-scheme="primary"
                variant="solid"
                size="small"
                @click="submitTool"
            >
                {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BTNS.SAVE_CONF')}}
            </woot-button>
        </div>

        </div>


    </div>
    <LoadingState
        v-if="isLoading" :message="'Loading data...'"
    />
    </Modal>
</template>

<script>
import Modal from "dashboard/components/Modal.vue";
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import InputSlot from 'components/ui/inputs/MultiselectDropdown.vue'; // use as input slot
import InputField from 'components/ui/inputs/InputField.vue';
import InputCard from "components/ui/inputs/InputCard.vue";
import SliderRangeInput from "components/ui/inputs/SliderRangeInput.vue";
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";
import BodyNestedProprty from "./BodyNestedProprty.vue";
import llm_chatbotsAPI from "dashboard/api/llm_chatbots.js"
import { required, minLength, url, requiredIf } from 'vuelidate/lib/validators';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import DynamicVariablePiker from "./toolUI/DynamicVariablePiker.vue"
import ToolAPI from 'dashboard/api/tools.js';

/********* ZOD ********** */
// define the zod schema
import { z } from "zod";

// Base enums
const TypeEnum = z.object({
  label: z.string(),
  value: z.string(),
});

const ValueTypeEnum = z.object({
  label: z.string(),
  value: z.enum(["llmPrompt", "constantVariable", "dynamicVariable"]),
});


  // Recursive schema
  const PropertySchema = z.lazy(() =>
    z.object({
      required: z.boolean(),
      id: z.string().min(1, "id is required"),
      type: TypeEnum,
      description: z.string().optional(),
      dynamic_variable: z.any().nullable().optional(),
      constant_value: z.string().nullable().optional(),
      llm_description: z.string().optional(),
      value_type: ValueTypeEnum.optional(),

      properties: z.array(PropertySchema).optional(),

      items: z.lazy(() =>
        z
          .object({
            type: TypeEnum,
            description: z.string().optional(),
            constant_value: z.string().nullable().optional(),
            dynamic_variable: z.any().nullable().optional(),
            value_type: ValueTypeEnum.optional(),
            properties: z.array(PropertySchema).optional(),
            items: z.any().optional(), // nested array of array (optional)
          })
          .partial()
      ).optional(),
    }).superRefine((data, ctx) => {
      const typeValue = data.type?.value;
      const isComplex = typeValue === "object" || typeValue === "array";

      // [1] If object, properties must exist
      if (typeValue === "object" && !Array.isArray(data.properties)) {
        ctx.addIssue({
          path: ["properties"],
          code: z.ZodIssueCode.custom,
          message: "'properties' must be an array when type is 'object'",
        });
      }

      // [2] If array, items must exist
      if (typeValue === "array") {
        if (!data.items || typeof data.items !== "object") {
          ctx.addIssue({
            path: ["items"],
            code: z.ZodIssueCode.custom,
            message: "'items' must be defined when type is 'array'",
          });
        } else {
          // Recursive validator for items
          const validateItemsRecursively = (item, path) => {
            const itemType = item?.type?.value;
            const itemIsComplex = itemType === "object" || itemType === "array";

            if (!itemIsComplex) {
              const constVal = item?.constant_value;
              if (!constVal || constVal.toString().trim() === "") {
                ctx.addIssue({
                  path: [...path, "constant_value"],
                  code: z.ZodIssueCode.custom,
                  message:
                    "'constant_value' is required in primitive item inside nested array",
                });
              }
            }

            if (itemType === "array" && item.items) {
              validateItemsRecursively(item.items, [...path, "items"]);
            }
          };

          validateItemsRecursively(data.items, ["items"]);
        }
      }

      // [3] Validate value_type if primitive
      if (!isComplex) {
        const valType = data.value_type?.value;

        if (valType === "llmPrompt") {
          if (!data.description || data.description.trim() === "") {
            ctx.addIssue({
              path: ["description"],
              code: z.ZodIssueCode.custom,
              message: "'description' is required for value_type = llmPrompt",
            });
          }
        //   if (!data.required) {
        //     ctx.addIssue({
        //       path: ["required"],
        //       code: z.ZodIssueCode.custom,
        //       message: "Must be required if value_type is llmPrompt",
        //     });
        //   }
        }

        if (valType === "constantVariable" && !data.constant_value) {
          ctx.addIssue({
            path: ["constant_value"],
            code: z.ZodIssueCode.custom,
            message:
              "constant_value is required when value_type is constantVariable",
          });
        }

        if (valType === "dynamicVariable" && !data.dynamic_variable) {
          ctx.addIssue({
            path: ["dynamic_variable"],
            code: z.ZodIssueCode.custom,
            message:
              "dynamic_variable is required when value_type is dynamicVariable",
          });
        }
      }
    })
  );

// Main schema
const BodySchema = z.object({
  description: z.string().min(1, "Body description is required"),
  enabled: z.boolean(),
  properties: z.array(PropertySchema),
});


/********* ZOD ********** */



export default {
    components: {
        Modal,
        MultiselectDropdown,
        InputField,
        InputCard,
        SliderRangeInput,
        InputSlot,
        CheckboxInput,
        BodyNestedProprty,
        LoadingState,
        DynamicVariablePiker,
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        tool: {
            type: Object,
            default: () => ({
                url_endpoint: "",
                method: "",
                headers: "",
                prompt: "",
            }),
            required: false,
        },
        agentVariables:{
            type: Array,
            default: ()=>([])
        },
        isEditNewTool:{
            type: Boolean,
            default: false,
        },
        isDuplicateCreate:{
            type: Boolean,
            default: false,
        },
        toolType:{
            type: String,
            default: 'webhook',
        },
    },
    data(){
        return {
            isCloning: false,
            isLoading: false,
            isMounted: false,
            componentRerenderKey: 0, // used to force re-render
            validationVersion: 0,// dummy key to trigger reactivity
            bodyErr:{},


            // toolType: this.initialHookType || 'webhook',
             methods: [
                { value: 'GET', label: 'GET' },
                { value: 'POST', label: 'POST' },
                { value: 'PATCH', label: 'PATCH' },
                { value: 'PUT', label: 'PUT' },
                { value: 'DELETE', label: 'DELETE' },
            ],
            headerTypes: [
                {value:"value",label:"Value"},
                {value:"secret",label:"Secret"},
                // {value:"dynamicVariable",label:"Dynamic Variable"},
            ],
            secretList:[
                // {value:"secret1",label:"Secret 1"},
                // {value:"secret2",label:"Secret 2"},
            ],
            variableList:[
                // {value:"variable1",label:"variable 1"},
                // {value:"variable2",label:"variable 2"},
            ],
            paramDataTypes:[
                {value:"boolean",label:"Boolean"},
                {value:"integer",label:"Integer"},
                {value:"number",label:"Number"},
                {value:"string",label:"String"},
            ],
            paramValueTypes:[
                {value:"llmPrompt",label:"LLM prompt"},
                {value:"constantVariable",label:"Constant variable"},
                {value:"dynamicVariable",label:"Dynamic variable"},
            ],
            bodyDataTypes:[
                {value:"boolean",label:"Boolean"},
                {value:"integer",label:"Integer"},
                {value:"number",label:"Number"},
                {value:"string",label:"String"},
                {value:"object",label:"Object"},
                {value:"array",label:"Array"},
            ],

            // need replace variables
            config:{
                name:"",
                description:"",
                method:{ value: 'GET', label: 'GET' },
                url:"",
                timeout: 20,
                isWaitForRes: false,
            },
            headers:[
                // {
                //     headerType:{value:"value",label:"Value"},
                //     name:"",
                //     headerValue: null,
                // },
            ],
            pathParams:[
                // {
                //     type: {value:"string",label:"String"},   // dataType
                //     id:"account_id",  // identifier
                //     value_type: {value:"dynamicVariable",label:"Dynamic variable"},
                    // description:""
                    // dynamic_variable:{name:"",value:""}
                    // constant_value:""
                // },
            ],
            queryParams:[
                // {
                //     type:{value:"string",label:"String"},
                //     id:"",
                //     required: true,
                //     value_type: {value:"dynamicVariable",label:"Dynamic variable"},
                    // queryValue: null,
                    // description:""
                    // dynamic_variable:""
                    // constant_value:""
                // },
            ],
            body:{
                description:"",
                enabled:false,
                properties:[
                    // {
                    //     id: "",
                    //     type: this.bodyDataTypes[3],
                    //     description:"",
                    //     required: true,
                    //     dynamic_variable: "",
                    //     constant_value: "",
                    //     llm_description: "",
                    //     value_type: this.paramValueTypes[0],
                    // }
                ],
            },
        }
    },
    computed:{
        isClient(){
            return this.toolType === "client";
        },
        isHook(){
            return this.toolType === "webhook";
        },
    },
    watch: {

        /*
        // watch the body property is causing infinity loop
        body:{
            deep: true,
            handler(newVal) {
                if (this.isCloning) return; // prevent loop
                this.isCloning = true;
                setTimeout(() => {
                    const cloned = JSON.parse(JSON.stringify(newVal));
                    this.body = cloned;
                    console.log("Setting Cloned",cloned);
                    // this.$set(this, 'body', cloned);  // try this insed the above line


                    // allow next change
                    this.isCloning = false;
                }, 0); // next tick
            }
        },
        */
        /*
        'tool.id': function(newToolId){
            this.populateInitialFields(newToolId);
        },
        tool(newVal) {
            if (newVal?.name) {
                this.populateInitialFields();
            }
        },
        */
        tool: {
            immediate: true,
            deep: false,
            handler(newTool) {
                if (newTool && newTool.id) {
                    // console.log('[Watcher] Calling populateInitialFields with ID:', newTool.id);
                    this.populateInitialFields(newTool.id);
                } else if(newTool && newTool.name && !newTool.id){
                    // console.log('[Watcher] Tool object invalid or empty. Skipping.');
                    this.populateInitialFields();
                }
            }
        },

    },
    validations() {
        const _ = this.validationVersion; // force dependency
        const isWebhook = () => this.toolType === 'webhook';
        const isClient = () => this.toolType === 'client';
        const waitForResponse = () => this.config.isWaitForRes;


        function requiredIfValueType(type) {
            return function (value, vm) {
                const isSelected = vm?.value_type?.value === type;
                const isValid = value !== null && value !== undefined && value !== '';

                // console.log(`Validating for type "${type}"`, {
                // vm,
                // isSelected,
                // isValid,
                // valueType: vm?.value_type
                // });

                return isSelected ? isValid : true;
            };
        }









        return {
            config: {
                name: { required, minLength: minLength(1) },
                description: { required, minLength: minLength(1) },
                method: {
                    required: requiredIf(isWebhook),
                },
                url: {
                    required: requiredIf(isWebhook),
                    url: requiredIf(isWebhook),
                },
                timeout: {
                    required: requiredIf(() => isWebhook() || waitForResponse()),
                },
                isWaitForRes: {},
            },

            headers: {
            $each: {
                name: { required },
                headerType: { required },
                headerValue: {
                required: requiredIf(function () {
                    return ['value', 'secret', 'dynamicVariable'].includes(this.headerType?.value);
                }),
                },
            },
            },

            pathParams: {
                $each: {
                    id: { required },
                    type: { required },
                    value_type: { required },
                    description: {
                    isValidValue: requiredIfValueType('llmPrompt'),
                    },
                    constant_value: {
                    isValidValue: requiredIfValueType('constantVariable'),
                    },
                    dynamic_variable: {
                    isValidValue: requiredIfValueType('dynamicVariable'),
                    },
                },
            },

            queryParams: {
                $each: {
                    id: { required },
                    type: { required },
                    value_type: { required },
                    required: {},
                    description: {
                    isValidValue: requiredIfValueType('llmPrompt'),
                    },
                    constant_value: {
                    isValidValue: requiredIfValueType('constantVariable'),
                    },
                    dynamic_variable: {
                    isValidValue: requiredIfValueType('dynamicVariable'),
                    },
                },
            },




            // variableList: {
            //     $each: {
            //         label: { required },
            //         value: { required },
            //     },
            // },
        };
    },

    methods: {
        async submitTool() {
            this.validationVersion++; // force re-evaluation
            await this.$nextTick(() => {});

            // do validation
            this.$v.$reset();
            this.$v.config.$touch();
            this.$v.headers.$touch();
            this.$v.pathParams.$touch();
            this.$v.queryParams.$touch();
            // this.$v.variableList.$touch();

            if (this.isHook || (this.isClient && this.config.isWaitForRes)) {
                // this.$v.config.timeout.$touch();
            }

            if (this.body.enabled) {
                this.bodyErr = {}
                // console.log("touching body",this.body);
                const result = BodySchema.safeParse(this.body);
                // console.log(result.success ? "✅ Valid" : null);
                console.dir(result.error?.format(),{depth:null});
                if (!result.success) {
                    this.bodyErr = result.error?.format(),
                    console.log("Body validation fail",this.body);
                    return
                }
            }

            if (
            this.$v.config.$invalid ||
            this.$v.headers.$invalid ||
            this.$v.pathParams.$invalid ||
            this.$v.queryParams.$invalid
            // this.$v.variableList.$invalid
            // (this.body.enabled && this.$v.body.$invalid)
            ) {
                console.log('Validation failed', this.$v);
                // console.log(this.$v.body.properties);
                return;
            }


            try {
                // prepare payload
                let payload = {
                    toolType: this.toolType,
                    config: this.config,
                    headers: this.headers,
                    pathParams: this.pathParams,
                    queryParams: this.queryParams,
                    body: this.body,
                    variables: this.variableList,
                }
                if (this.isClient) {
                    payload = {
                        toolType: this.toolType,
                        config: {
                            name: this.config.name,
                            description: this.config.description,
                            timeout: this.config.timeout,
                            isWaitForRes: this.config.isWaitForRes,
                        },
                        queryParams: this.queryParams,
                        variables: this.variableList,
                    }
                }

                let newTool;

                if (this.isClient) {
                    // Simplified format for client mode
                    newTool = {
                        type: this.toolType,
                        name: this.config.name,
                        description: this.config.description,
                        settings: {
                            url: '', // No URL provided in isClient block
                            method: '', // No method provided in isClient block
                            path_params_schema: [],
                            query_params_schema: this.queryParams || [],
                            request_body_schema: null,
                            request_headers: [],
                            response_timeout_secs: this.config.timeout,
                        },
                        dynamic_variables: {
                            variableList: this.variableList || []
                        }
                    };
                } else {
                    // Full format
                    newTool = {
                        type: this.toolType,
                        name: this.config.name,
                        description: this.config.description,
                        settings: {
                            url: this.config.url,
                            method: this.config.method.value,
                            path_params_schema: this.pathParams || [],
                            query_params_schema: this.queryParams || [],
                            request_body_schema: this.body?.enabled ? this.body : null,
                            request_headers: this.headers || [],
                            response_timeout_secs: this.config.timeout,
                        },
                        dynamic_variables: {
                            variableList: this.variableList || []
                        }
                    };
                }

                console.log(this.tool,this.newTool,this.toolType);

                if (this.tool?.id && !this.isDuplicateCreate) {
                    // Case 1: Tool has real DB ID
                    this.$emit("onUpdate",{...newTool,id:this.tool.id});
                } else if(this.tool.new_tool_id && !this.isDuplicateCreate){
                    // Case 2: New tool being re-edited (already has new_tool_id)
                    this.$emit("onUpdate",{...newTool,new_tool_id:this.tool.new_tool_id});
                } else {
                    // Case 3: Brand new tool (no id or new_tool_id)
                    newTool.new_tool_id = this.tool.new_tool_id || Date.now();

                    this.$emit("onAdd",newTool);
                }
                // cleare all fields
                this.resetDefaultForm();
                 this.$v.$reset();
                await this.$nextTick();
                this.onClose();
            } catch (error) {
                console.log(error);
            }
        },
        resetDefaultForm(){
            this.config = {
                name:"",
                description:"",
                method:{ value: 'GET', label: 'GET' },
                url:"",
                timeout: 20,
                isWaitForRes: false,
            }
            this.headers = [];
            this.pathParams = [];
            this.queryParams = [];
            this.body = {
                description:"",
                enabled:false,
                properties:[],
            };
        },
        async populateInitialFields(tool_id,isOnClose=false){
            // console.log("Populating Tool",{tool_id});
            try {
                this.isLoading = true;
                if (tool_id) {
                    // const {data:exTool} = await llm_chatbotsAPI.fetchToolsByLLMid(this.$route.params.llm_bot_id,tool_id);
                    const {data:exTool} = await ToolAPI.fetchToolById(tool_id);
                    // console.log("exTool",exTool);
                    // populate the fields
                    this.config = {
                        ...this.config,
                        name: this.isDuplicateCreate ? `${exTool.name}(1)` : exTool.name,
                        description: exTool.description,

                        method: this.methods.find(el=>el.value === exTool.settings.method) || this.methods[0],
                        url: exTool.settings.url,
                        timeout: exTool.settings.response_timeout_secs || 20,
                        // isWaitForRes: false,
                    };
                    this.headers = exTool.settings.request_headers || [];
                    this.pathParams = exTool.settings.path_params_schema || [];
                    this.queryParams = exTool.settings.query_params_schema || [];
                    // this.body = exTool.settings.request_body_schema || this.body;
                    this.$set(this, 'body', JSON.parse(JSON.stringify(exTool.settings.request_body_schema || {})));

                    // this.headers = [];
                    // console.log("Populate body",this.body);

                }else{
                    // console.log("calling not tool_id",this.tool);
                    // it is new tool and populate fields
                    // Populate from new tool object (passed in as prop)
                    let tool = {}
                    if (!isOnClose) {
                        tool = this.tool;
                    }

                    this.config = {
                        ...this.config,
                        name: tool.name || '',
                        description: tool.description || '',
                        method:
                        this.methods.find((el) => el.value === tool.api_schema?.method) ||
                        this.methods[0],
                        url: tool.api_schema?.url || '',
                        timeout: tool.response_timeout_secs || 30,
                    };
                    this.headers = tool.api_schema?.request_headers || [];
                    this.pathParams = tool.api_schema?.path_params_schema || [];
                    this.queryParams = tool.api_schema?.query_params_schema || [];
                    this.body = tool.api_schema?.request_body_schema ||  {description:"",enabled:false,properties:[]};
                    this.variableList = tool.dynamic_variables?.variableList || [];

                    // console.log("Conf",this.config,tool,{isOnClose});
                }
                this.componentRerenderKey++; // re-render component
                console.log(this.config);
            } catch (error) {
                console.log(error);
            }finally{
                this.isLoading =false;
            }
        },
        onCloseModal(){
            this.populateInitialFields(null,true);
            this.onClose();
        },
        onBlurUrl(newUrl){
            const variablePattern = /{([^}]+)}/g;
            const matches = newUrl.matchAll(variablePattern);
            const variablesInUrl = Array.from(matches, m => m[1]);

            // Remove items not in URL
            this.pathParams = this.pathParams.filter(param =>
                variablesInUrl.includes(param.id)
            );

            // Add new variables not already present
            variablesInUrl.forEach(id => {
                const exists = this.pathParams.some(p => p.id === id);
                if (!exists) {
                this.pathParams.push({
                    type: this.paramDataTypes[3],
                    id,
                    value_type: this.paramValueTypes[0],
                    // pathValue: null,
                    description:"",
                    // dynamic_variable:{name:"",value:""},
                    dynamic_variable: null,
                    constant_value:"",
                    required: true,
                });
                }
            })
        },
        onSelectValueTypeOnPathParam(selectedItem,index,){
            if (selectedItem.value === "llmPrompt") {
                this.pathParams[index].required = true;
            }else{
                this.pathParams[index].required = false;
            }
        },

        addNewHeader(){
            this.headers.push({
                headerType:{value:"value",label:"Value"},
                name:"",
                headerValue: null,
            })
        },
        deleteAHeader(index){
            this.headers.splice(index, 1);
        },
        addNewQueryParams(){
            this.queryParams.push({
                type: this.paramDataTypes[3],
                id:"",
                required: true,
                value_type: this.paramValueTypes[0],
                // queryValue:null,
                description:"",
                // dynamic_variable:{name:"",value:""},
                dynamic_variable: null,
                constant_value:""
            })
        },
        deleteQueryParam(index){
            this.queryParams.splice(index, 1);
        },
        onToggleQueryParamRequired(index){
            this.queryParams[index].required = !this.queryParams[index].required;
        },
        onSelectValueTypeOnQueryParam(selectedItem,index,){
            if (selectedItem.value === "llmPrompt") {
                this.queryParams[index].required = true;
            }else{
                this.queryParams[index].required = false;
            }
        },
        enableBodyParams(){
            this.body.enabled = true;
        },
        addBodyProperty(){
            this.body.properties.push({
                id: "",
                type: this.bodyDataTypes[3],
                description:"",
                required: true,
                dynamic_variable: {name:"",value:""},
                constant_value: "",
                // llm_description: "",
                value_type: this.paramValueTypes[0],
            })
        },

        addNewVariable(){
            this.variableList.unshift({value:"",label:""})
        },
        deleteVariable(index){
            this.variableList.splice(index, 1);
        },
        onToggleWaitForResponse(){
            this.config.isWaitForRes = !this.config.isWaitForRes;
        },

    },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.tool_types{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 2rem;
    button{
        border: 1px solid var(--s-75);
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
        &:hover{
            background: var(--s-25);
        }
    }
    .active_btn{
        background: var(--s-25);
    }
}
.llm_tool_input_field{
    .field_wrapper{
        background: #fff;
    }
}
.dropdown_input_group{
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 1rem;
}

.tool_section{
    position: relative;
    min-height: 44px;
    .add_btn{
        position: absolute;
        top: 6px;
        right: 6px;
    }
    .add_btn_center{
        width: fit-content;
        margin: auto;
    }
}
.add_body_property_btn{
    display: flex;
    justify-items: center;
    justify-content: center;
}

.variable_input_group{
    display: grid;
    grid-template-columns: 150px 1fr 50px;
    gap: 10px;
}
</style>